:host {
  display: block;
}

.nav-list {
  list-style: disc;
  padding: 6px;
  max-width: 350px;
}

.nav-link {
  font-family: 'TradeGothic2022';
  font-size: var(--cms-font-size-150);
  color: var(--cms-theme-text-color);
  display: block;
  text-decoration: none;
  padding: 4px;
}

.nav-link:hover {
  background-color: #333;
  color: #fff;
}